<template>
    <div>
        <iframe
          v-if="code.length"
          width="560"
          height="315"
          :src="`https://www.youtube.com/embed/${code}?showinfo=0&rel=0`"
          frameborder="0"
          allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
          showinfo="0"
          allowfullscreen
        >
        </iframe>
    </div>
</template>
<script>

export default {
  name: 'video',
  props: ['code']

}
</script>
